import React, { useState } from "react";
import { Typography, Grid, TextField, Button } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { deleteAccountOTPConfirm, deleteAccountOTPReq } from "actions/contactActions";
import { useDispatch } from "react-redux";

const UserDeleteForm = ({ appname }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isOTPRequested, setIsOTPRequested] = useState(false);

  const formik = useFormik({
    initialValues: {
      businessName: appname,
      mobile: "",
      otp: "",
    },
    validationSchema: Yup.object({
      mobile: Yup.string()
        .max(10, "Must be 10 digits")
        .matches(/^[0-9]{10}$/, "Please enter a valid 10-digit number")
        .required("Mobile number is required"),
      otp: Yup.string()
        .max(6, "Must be 6 digits")
        .matches(/^[0-9]*$/, "Please enter a valid OTP"),
    }),
    onSubmit: async (values) => {

      
      try {
        if (!isOTPRequested) {
          await dispatch(deleteAccountOTPReq(appname, values.mobile));
          setIsOTPRequested(true);
        } else {
          await dispatch(deleteAccountOTPConfirm(appname, values.mobile, values.otp));
          // Optionally navigate or show success
        }
      } catch (error) {
        console.error("Form submission error:", error);
      }
    },
  });

  return (
    <Grid>
      <Typography variant="h4">Delete My Account</Typography>
      <Typography variant="subtitle1">App Name: {appname}</Typography>

      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={3} sx={{ pt: 2 }} xs={6}>
          <Grid item xs={12} >
            <TextField
              id="mobile"
              name="mobile"
              label="Mobile No"
              variant="outlined"
              required
              fullWidth
              type="number"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.mobile}
              error={formik.touched.mobile && Boolean(formik.errors.mobile)}
              helperText={formik.touched.mobile && formik.errors.mobile}              
            />
          </Grid>

          {isOTPRequested && (
            <Grid item xs={12}>
              <TextField
                id="otp"
                name="otp"
                label="OTP"
                variant="outlined"
                required
                fullWidth
                type="number"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.otp}
                error={formik.touched.otp && Boolean(formik.errors.otp)}
                helperText={formik.touched.otp && formik.errors.otp}                
              />
            </Grid>
          )}
        </Grid>

        {isOTPRequested && (
          <Typography variant="subtitle2" sx={{ mt: 2 }}>
            Note: Once the account is deleted, you will lose access to the application and all data will be removed permanently.
          </Typography>
        )}

        <Grid container spacing={2} sx={{ pt: 3 }}>
          <Grid item>
            <Button
              variant="contained"
              type="submit"
              sx={{ borderRadius: "23px" }}
            >
              {isOTPRequested ? "Confirm Delete" : "Request Delete OTP"}
            </Button>
          </Grid>

          {isOTPRequested && (
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => navigate("/home")}
                sx={{
                  borderColor: "secondary.main",
                  color: "secondary.light",
                  borderRadius: "23px",
                }}
              >
                Cancel
              </Button>
            </Grid>
          )}
        </Grid>
      </form>
    </Grid>
  );
};

export default UserDeleteForm;
